import { listen, qs, qsa, add } from "@fluorescent/dom";
import { slideDown, slideUp, slideStop, isVisible } from "slide-anim";

function Accordion(node) {
  const labels = qsa(".accordion__label", node);

  // Make it accessible by keyboard
  labels.forEach(label => {
    label.href = "#";
    const icon = document.createElement("div");
    icon.classList.add("icon");
    icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24"><path d="M7 10L12 15L17 10H7Z" fill="currentColor"/></svg>`;

    label.append(icon);
  });

  const labelClick = listen(labels, "click", e => {
    const { parentNode: group, nextElementSibling: content } = e.currentTarget;
    e.preventDefault();
    slideStop(content);

    if (isVisible(content)) {
      slideUp(content);
      group.setAttribute("data-open", false);
    } else {
      slideDown(content);
      group.setAttribute("data-open", true);
    }
  });

  // Nicer way to do this? show in CSS?
  const openGroups = qsa('.accordion__group[data-open="true"]', node);
  openGroups.forEach(group => qs(".accordion__label", group).click());

  function destroy() {
    return () => labelClick();
  }

  return { destroy };
}

export default function Accordions(nodes) {
  const accordions = nodes.map(Accordion);

  function destroy() {
    accordions.forEach(accordion => accordion.destroy());
  }

  return { accordions, destroy };
}
